import i18n from "i18next";
import ICU from "i18next-icu";
import { initReactI18next } from "react-i18next";
import { AppDistribution } from "@/types/common.types.ts";
import { getAppAssistantName } from "@/utils/app-assistant-name.ts";

type TranslationResources = {
  [language: string]: {
    [namespace: string]: { [key: string]: string };
  };
};

export function loadTranslations(): TranslationResources {
  const resources: TranslationResources = {};
  const modules = import.meta.glob("./locales/**/*.json", {
    eager: true,
    import: "default",
  });

  for (const path in modules) {
    const jsonContent = modules[path] as Record<string, string>;

    const pathParts = path.split("/");
    const language = pathParts[2];
    const namespace = pathParts[3].replace(".json", "");

    if (!resources[language]) {
      resources[language] = { translation: {} };
    }
    if (!resources[language][namespace]) {
      resources[language][namespace] = {};
    }

    const appName = import.meta.env.VITE_APP_NAME;
    const appAIName = import.meta.env.VITE_APP_AI_NAME;
    const appAssistantName = getAppAssistantName(import.meta.env.VITE_APP_DISTRIBUTION, appAIName);
    if (appName) {
      for (const key in jsonContent) {
        jsonContent[key] = jsonContent[key].replace(/%APP_NAME%/g, appName);
        jsonContent[key] = jsonContent[key].replace(/%APP_AI_NAME%/g, appAIName);
        jsonContent[key] = jsonContent[key].replace(/%APP_ASSISTANT_NAME%/g, appAssistantName);
      }
    }

    Object.assign(resources[language][namespace], jsonContent);
  }

  return resources;
}

export function initializeI18n() {
  const resources = loadTranslations();

  i18n
    .use(ICU)
    .use(initReactI18next)
    .init({
      resources,
      debug: false,
      lng: import.meta.env.VITE_APP_DISTRIBUTION == AppDistribution.headly ? "ru" : "en",
      keySeparator: false, // we do not use keys in form messages.welcome
      // ns: ["ats", "common", "app"],
      nsSeparator: ":",
      interpolation: {
        escapeValue: false,
      },
    });
}

initializeI18n();

i18n.on("languageChanged", (lng) => {
  document.documentElement.lang = lng;
});

export default i18n;
